/*
 * @Author: hujie striveyf@dingtalk.com
 * @Date: 2023-06-22 11:10:48
 * @LastEditors: hujie striveyf@dingtalk.com
 * @LastEditTime: 2023-06-23 16:38:10
 * @FilePath: \vysa_wifi_web\src\store\index.ts
 * @Description: vuex
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { createStore } from 'vuex'

export default createStore({
  state: {
    appId: undefined, //微信签名用
    tenantId: undefined, //cmeId
    userId: undefined, //购买套餐用
    kfUrl: undefined,
  },
  mutations: {
    setAppid(state, data) {
      state.appId = data
      sessionStorage.setItem("appId", data);
    },
    setTenantId(state, data) {
      state.tenantId = data
      sessionStorage.setItem("tenantId", data);
    },
    setUserId(state, data) {
      state.userId = data
      sessionStorage.setItem("userId", data);
    },
    setKfUrl(state, data) {
      state.kfUrl = data
      sessionStorage.setItem("kfUrl", data);
    },
  },
  actions: {
  },
  modules: {
  }
})
